import { createTheme } from "@mui/material/styles";
import getCssVariable from "../App/validation/getCssVariable";
import "../Style/main/variable.css"

const themeOptions = {
  palette: {
    mode: document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light",
    primary: {
      main: getCssVariable("--accent"),
      contrastText: getCssVariable("--text-active"),
    },
    secondary: {
      main: getCssVariable("--base"),
      contrastText: getCssVariable("--accent"),
    },
    tertiary: {
      main: getCssVariable("--pasive"),
      contrastText: getCssVariable("--text-active"),
    },
    active: {
      main: getCssVariable("--active"),
      contrastText: getCssVariable("--text-active"),
    },
    "text-active": { main: getCssVariable("--text-active") },
    "text-pasive": { main: getCssVariable("--text-pasive") },
    blue: {
      main: getCssVariable("--blue"),
      contrastText: getCssVariable("--text-active")
    },
  },
};

const theme = createTheme(themeOptions);

export default theme;